export const EXPENSE_WORKPLACES = [
  { value: 'Store', label: 'Store' },
  { value: 'Shop', label: 'Shop' }
] as const;

export const EXPENSE_CATEGORIES = [
  { value: 'Rent', label: 'Rent' },
  { value: 'Utilities', label: 'Utilities' },
  { value: 'Repairs', label: 'Repairs' },
  { value: 'Supplies', label: 'Supplies' },
  { value: 'PettyCash', label: 'Petty cash' },
  { value: 'Transportation', label: 'Transportation' },
  { value: 'Other', label: 'Other' }
] as const;

export const EXPENSE_PAYMENT_METHODS = [
  { value: 'Cash', label: 'Cash' },
  { value: 'BankTransfer', label: 'Bank transfer' },
  { value: 'GCash', label: 'GCash' },
  { value: 'Check', label: 'Check' },
  { value: 'Other', label: 'Other' }
] as const;

export type ExpenseWorkplace = (typeof EXPENSE_WORKPLACES)[number]['value'];
export type ExpenseCategory = (typeof EXPENSE_CATEGORIES)[number]['value'];
export type ExpensePaymentMethod =
  | (typeof EXPENSE_PAYMENT_METHODS)[number]['value']
  | 'Fund';

export type ShopFundDirection = 'Credit' | 'Debit';

export type OperatingExpense = {
  rowKind?: 'Expense' | 'ShopFund';
  operatingExpenseId: number;
  shopFundEntryId?: number | null;
  fundDirection?: ShopFundDirection | null;
  expenseDate: string;
  workplace?: ExpenseWorkplace | null;
  workplaceLabel: string;
  category?: ExpenseCategory | null;
  categoryLabel: string;
  payee: string;
  description: string;
  amount: number;
  paymentMethod?: ExpensePaymentMethod | null;
  fundId?: number | null;
  fundName?: string | null;
  paymentMethodLabel: string;
  reference?: string | null;
  isVoided: boolean;
  voidReason?: string | null;
};

export type OperatingExpenseSummary = {
  totalAmount: number;
  categoryTotals: {
    category: ExpenseCategory;
    categoryLabel: string;
    amount: number;
  }[];
};

export type OperatingExpensePreviewRow = {
  rowNumber: number;
  status: string;
  message?: string | null;
  expenseDate?: string | null;
  workplace?: string | null;
  workplaceLabel?: string | null;
  category?: string | null;
  categoryLabel?: string | null;
  payee?: string | null;
  description?: string | null;
  amount?: number | null;
  amountText?: string | null;
  paymentMethod?: string | null;
  fundId?: number | null;
  paymentMethodLabel?: string | null;
  reference?: string | null;
};

export type OperatingExpensePreview = {
  fileName: string;
  readyCount: number;
  errorCount: number;
  rows: OperatingExpensePreviewRow[];
};

export type FundBalance = {
  fundId: number;
  name: string;
  balance: number;
  totalCredits: number;
  totalDebits: number;
};

export type BranchFunds = {
  funds: FundBalance[];
};

export const formatPesos = (amount: number | null | undefined) => {
  if (amount === null || amount === undefined || Number.isNaN(amount)) {
    return '—';
  }
  return `PHP ${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};
